import { backgroundInfoType, companyInfosJsonType, companyType, logoMapperType } from "../tpyes/company-info-type";
//@ts-ignore
// import Logo from 'src/static/icon.png';
import {ICONS} from '../static/company-icons'
//@ts-ignore
import { STATIC_ROOT } from '../static'

const COMPANY_INFO_RAW:Array<companyInfosJsonType> = STATIC_ROOT.companyInfoJSON

export const LOGO_MAPPER:Array<backgroundInfoType> = [
    { logo : ICONS.FUNDING_SOCIETY_ICON,},
    { logo : ICONS.COLLECTIUS_ICON,},
    { logo : ICONS.REFINN_ICON,backgroundColor:"rgba(54,149,215,255)"},
    { logo : ICONS.FINOMENA_ICON,backgroundColor:"black"},
    { logo : ICONS.SMART_CONTRACT_ICON,},
    { logo : ICONS.APPMAN_ICON,},
    { logo : ICONS.TOEXIT_ICON,},
    { logo : ICONS.SHOPEE_PAY_ICON,},
    { logo : ICONS.PROMPT_NOW_ICON,},
    { logo : ICONS.TQD_ICON,},

    { logo : ICONS.TCC_TECH_ICON,},
    { logo : ICONS.INNO_SW_CONSUL_ICON,},
    { logo : ICONS.DEEP_SCOPE_ICON,backgroundColor:"rgba(15,55,80,255)"},
    { logo : ICONS.PRAIN_FINTECH_ICON,}, //unk
    { logo : ICONS.ODINI_ICON,},
    { logo : ICONS.SINWATTANA_ICON,},
    { logo : ICONS.DREAM_MAKER_ICON,},
    { logo : ICONS.TRUST_TENDER_ICON,}, 
    { logo : ICONS.BITKUB_ICON,},
    //before

    //after 35 companies
    { logo : ICONS.ANS_BROKERPAGE_ICON,}, //id == 20
    { logo : ICONS.TRIS_RATING_ICON,},
    { logo : ICONS.THAI_BMA_ICON,},
    { logo : ICONS.LUCKY_LEASING_ICON,},
    { logo : ICONS.ZIPMEX_ICON,},
    { logo : ICONS.ASCO_ICON,},
    { logo : ICONS.DEE_MONEY_ICON,},
    { logo : ICONS.MASII_ICON,},
    { logo : ICONS.BILL_ME_ICON,},
    { logo : ICONS.TAS_MAEW_ICON,},

    { logo : ICONS.WEALTHI_ICON,},
    { logo : ICONS.DOLLAR_SMART_ICON,},
    { logo : ICONS.INVES_TREE_ICON,},
    { logo : ICONS.NESTIFY_ICON,},
    { logo : ICONS.SMART_FINN_ICON,},
    { logo : ICONS.CLAIM_DI_ICON,},
    { logo : ICONS.PEER_POWER_ICON,},
    { logo : ICONS.ILCT_ICON,},
    { logo : ICONS.ASSET_WORLD_CORP_ICON,},
    { logo : ICONS.TRUST_LESS_BANK_ICON,},


    { logo : ICONS.MARKET_724,},
    { logo : ICONS.FRIENDS_FOR_DISABILITY_ICON,},
    { logo : ICONS.DATA_ONE_ICON,},
    { logo : ICONS.UTU_ICON,},
    { logo : ICONS.PEAK_ICON,backgroundColor:"rgba(12,171,217,255)"},
    { logo : ICONS.BCI_LOGO,},
    { logo : ICONS.CHOMCHOB_ICON,},
    { logo : ICONS.SIAM_VALIDUS_ICON,backgroundColor:"rgba(199,34,41,255)"},
    { logo : ICONS.J_VENTURE_ICON,},
    { logo : ICONS.UP_BIT_ICON,},


    { logo : ICONS.DURIAN_CORP_ICON,},
    { logo : ICONS.NAKORN_LEASING_ICON,},
    { logo : ICONS.MONEY_WE_CAN_ICON,},
    { logo : ICONS.T2P_ICON,},
    { logo : ICONS.ATATO_ICON,},

    { logo : ICONS.SATANG_PRO_ICON,backgroundColor:"rgba(54,92,169,255)"},
    { logo : ICONS.HUOBI_ICON,},
    { logo : ICONS.EXR_ICON,},
    { logo : ICONS.Z_ICON,backgroundColor:"rgba(184,43,46,255)"},
]

export const founderParser = (founders:string|undefined) => {
    if (!founders) return ["-"]
    let _founders = founders.split(",")
    return _founders
}

export const countryServedParser = (founders:string|undefined) => {
    if (!founders) return ["-"]
    let _founders = founders.split(";")
    return _founders
}

interface sectionMapperType {
    [level2:string] : string
}

export const SECTOR_MAPPER:sectionMapperType = {
    "Balance Sheet Business Lending" : "Digital Lending",
    "Balance Sheet Property Lending" : "Digital Lending",
    "Balance Sheet Consumer Lending" : "Digital Lending",
    "P2P / Marketplace Lending" : "Digital Lending",
    "P2P / Marketplace Business Lending" : "Digital Lending",
    "P2P / Marketplace Property Lending" : "Digital Lending",
    "P2P / Marketplace Consumer Lending" : "Digital Lending",
    "Debt-Based Securities" : "Digital Lending",
    "Mini-Bonds" : "Digital Lending",
    "Invoice Trading" : "Digital Lending",
    "Crowd-Led Microfinance" : "Digital Lending",
    "Customer Cash-Advance" : "Digital Lending",
    "Merchant Cash-Advance" : "Digital Lending",

    "Equity-Based Crowdfunding" : "Digital Capital Raising",
    "Revenue / Profit Share Crowdfunding" : "Digital Capital Raising",
    "Real Estate Crowdfunding" : "Digital Capital Raising",
    "Community Shares" : "Digital Capital Raising",
    "Capital Raising Retail Brokerage" : "Digital Capital Raising",
    "Capital Raising Institutional Brokerage" : "Digital Capital Raising",

    "Fully Digitally Native Bank (Retail)" : "Digital Banks",
    "Marketplace Bank (Retail)" : "Digital Banks",
    "Fully Digitally Native Bank (MSME)" : "Digital Banks",
    "Marketplace Bank (MSME)" : "Digital Banks",
    "Banking-as-a-Service (BaaS)" : "Digital Banks",
    "Agent Banking (Cash-In / Cash-Out)" : "Digital Banks",

    "Digital Money Market / Fund" : "Digital Savings",
    "Digital Micro Saving Solutions" : "Digital Savings",
    "Digital Savings Collective / Pool" : "Digital Savings",
    "Savings-as-a-Service (SaaS)" : "Digital Savings",

    "Digital Remittances (Cross Border-P2P)" : "Digital Payments",
    "Digital Remittances (Domestic-P2P)" : "Digital Payments",
    "Money Transfer (P2P / P2B / B2P / B2B)" : "Digital Payments",
    "eMoney Issuers" : "Digital Payments",
    "Mobile Money" : "Digital Payments",
    "Acquiring Services Providers for Merchants" : "Digital Payments",
    "Points of Access (PoS / mPoS / Online PoS)" : "Digital Payments",
    "Bulk Payment Solutions" : "Digital Payments",
    "Top-ups & Refills" : "Digital Payments",
    "Payment Gateways" : "Digital Payments",
    "Payment Aggregators" : "Digital Payments",
    "API Hubs for Payments" : "Digital Payments",
    "Settlement & Clearing Services Providers" : "Digital Payments",
    "Money Transfer (Cryptoasset)" : "Digital Payments",
    "Consumer Spending" : "Digital Payments",
    "Top-ups & Refill (Cryptoasset)" : "Digital Payments",
    "Payment Processor" : "Digital Payments",
    "Points of Access (Cryptoasset)" : "Digital Payments",
    "Asset-Backed Stablecoin"  : "Digital Payments",
    "Algorithmic Stablecoin" : "Digital Payments",

    "Order-Book" : "CryptoassetExchange",
    "Decentralised Exchange (DEX) Relayer" : "CryptoassetExchange",
    "Single Dealer Platform / OTC Trading" : "CryptoassetExchange",
    "Trading Bots" : "CryptoassetExchange",
    "High-Frequency Trading (HFT) Services" : "CryptoassetExchange",
    "Advanced Trading Services" : "CryptoassetExchange",
    "Retail Brokerage Services" : "CryptoassetExchange",
    "Institutional Brokerage Services" : "CryptoassetExchange",
    "Aggregation" : "CryptoassetExchange",
    "Bitcoin Teller Machines (BTM)" : "CryptoassetExchange",
    "P2P Cryptoasset Marketplaces" : "CryptoassetExchange",
    "Clearing" : "CryptoassetExchange",

    "Third-Party Custody" : "Digital Custody",
    "Co-Managed Custody" : "Digital Custody",
    "Hardware Cryptoasset Wallet" : "Digital Custody",
    "Unhosted Cryptoasset Wallet" : "Digital Custody",
    "Hosted Cryptoasset Wallet" : "Digital Custody",
    "eMoney Wallet" : "Digital Custody",
    "Key Management Services" : "Digital Custody",

    "Usage-Based Insurance" : "InsurTech",
    "Parametric-Based Insurance" : "InsurTech",
    "On-Demand Insurance" : "InsurTech",
    "P2P Insurance" : "InsurTech",
    "Technical Service Provider (TSP)" : "InsurTech",
    "Digital Brokers or Agents" : "InsurTech",
    "Comparison Portal" : "InsurTech",
    "Customer Management" : "InsurTech",
    "Claims & Risk Management Solutions" : "InsurTech",
    "IoT (including Telematics)" : "InsurTech",

    "Digital Wealth Management" : "WealthTech",
    "Social Trading" : "WealthTech",
    "Robo-Advisors" : "WealthTech",
    "Pension-Led Funding" : "WealthTech",
    "Robo Retirement / Pension Planning" : "WealthTech",
    "Personal Financial Management / Planning" : "WealthTech",
    "Financial Comparison Sites" : "WealthTech",

    "Profiling & Due Diligence" : "RegTech",
    "Blockchain Forensics" : "RegTech",
    "Risk Analytics" : "RegTech",
    "Dynamic Compliance" : "RegTech",
    "Regulatory Reporting" : "RegTech",
    "Market Monitoring" : "RegTech",

    "Psychometric Analytics" : "Alternative Credit Analytics",
    "Sociometric Analytics" : "Alternative Credit Analytics",
    "Biometric Analytics" : "Alternative Credit Analytics",
    "Alternative Credit Rating Agency" : "Alternative Credit Analytics",
    "Credit Scoring" : "Alternative Credit Analytics",

    "Security & Biometrics" : "Digital Identity",
    "KYC Solutions" : "Digital Identity",
    "Fraud Prevention & Risk Management" : "Digital Identity",

    "API Management" : "Tech. for Enterprise",
    "Cloud Computing" : "Tech. for Enterprise",
    "AI / ML / NLP" : "Tech. for Enterprise",
    "Enterprise Blockchain" : "Tech. for Enterprise",
    "Financial Management & Business Intelligence" : "Tech. for Enterprise",
    "Digital Accounting" : "Tech. for Enterprise",
    "Electronic Invoicing" : "Tech. for Enterprise",

    "Hardware Manufacturing" : "Consensus Services",
    "Remote Hosting Services" : "Consensus Services",
    "Cloud Mining" : "Consensus Services",
    "Hashrate Brokerage" : "Consensus Services",
    "Proprietary Hashing" : "Consensus Services",
    "Pool Operation" : "Consensus Services",
    "Equipment Procurement & Financing" : "Consensus Services",
    "Firmware & Software Development" : "Consensus Services",
    "Staking-as-a-Service" : "Consensus Services",
    }
export const sectionParsed = (section:string|undefined) => {
    if (!section) return ["Other"]
    let result:Array<string> = []
    let sections = section.split(";")

    let categories:Array<string> = []
    sections.forEach((_section)=>{
        let currentCategory = SECTOR_MAPPER[_section.trim()] || "Other"
        if (categories.includes(currentCategory) === false) {
            categories.push(currentCategory)
        } 

    })
    return categories
}

export const companyInfosReader = () => {
    let result:Array<companyType> = []
    COMPANY_INFO_RAW.map((companyInfoRaw,index)=>{
        let parsed:companyType = {
            website : companyInfoRaw.website,
            registeredName : companyInfoRaw.registeredName,
            tradeName : companyInfoRaw.tradeName,
            sns : {
                linkedIn : companyInfoRaw.linkedin 
            },
            categories : [companyInfoRaw.sector],
            companyInfo : {
                desc : companyInfoRaw.companyDescription,
                founder : founderParser(companyInfoRaw.founders),
                contactEmail : companyInfoRaw.contactEmail,
                urlToCcafMapping : companyInfoRaw.urlToCcafMapping,
                backgroundColor : LOGO_MAPPER[index]?.backgroundColor,
                logo : LOGO_MAPPER[index]?.logo,
            },
            incorporation : {
                city : companyInfoRaw.incorporationCity,
                date : companyInfoRaw.incorporationDate,
                country : companyInfoRaw.incorporationCountry,
                countryServed : countryServedParser(companyInfoRaw.countriesServed),
                operationalCity : companyInfoRaw.operationalCity,
                operationalHq : companyInfoRaw.operationalHQ,
            }
        }
        result.push(parsed)
    })
    return result
}
